// frontend/src/services/title/titleService.js
import api from '../api';
import errorService from '../error/errorService';

/**
 * Title Service - Handles document title generation operations
 */
class TitleService {
  /**
   * Generate a title for a document using AI
   * @param {string} text - The text content to generate a title from
   * @returns {Promise<string>} - Promise that resolves with the generated title
   */
  async generateTitle(text) {
    try {
      // Limit input to prevent abuse (first 2000 chars should be enough for title generation)
      const truncatedText = text.substring(0, 2000);
      
      const response = await api.post('/generate-title', { 
        text: truncatedText 
      });
      
      if (!response.data || !response.data.title) {
        return "Untitled Document";
      }
      
      return response.data.title;
    } catch (error) {
      console.error("Title generation error:", error);
      // Return a fallback title if generation fails
      return `Untitled Document ${new Date().toISOString().slice(0, 10)}`;
    }
  }
}

export default new TitleService();